/** Capture the browser-only handoff before Sentry, analytics, or React start. */
const paths = new Set(['/integration-connected', '/figma-connected']);
const keyFor = (provider: string) => `oq:oauth-finalize:${provider}`;
let inMemory: { provider: string; handle: string } | null = null;

export function captureOAuthHandoff(): void {
  if (!paths.has(window.location.pathname)) return;
  const provider = window.location.pathname === '/figma-connected'
    ? 'figma' : new URLSearchParams(window.location.search).get('provider');
  const handle = new URLSearchParams(window.location.hash.slice(1)).get('handle');
  if (!provider || !handle) return;
  // Scrub even malformed handles: no handoff belongs in telemetry or history.
  window.history.replaceState(window.history.state, '', window.location.pathname + window.location.search);
  if (!/^[A-Za-z0-9_-]{43}$/.test(handle)) return;
  inMemory = { provider, handle };
  try { window.sessionStorage.setItem(keyFor(provider), handle); } catch { /* current tab still works */ }
}

export function readOAuthHandoff(provider: string): string | null {
  if (inMemory?.provider === provider) return inMemory.handle;
  try { return window.sessionStorage.getItem(keyFor(provider)); } catch { return null; }
}

export function clearOAuthHandoff(provider: string): void {
  if (inMemory?.provider === provider) inMemory = null;
  try { window.sessionStorage.removeItem(keyFor(provider)); } catch { /* best effort */ }
}

if (typeof window !== 'undefined') captureOAuthHandoff();
